import { setHiddenCableLockPlate, setHiddenCableMotorLead, setHiddenCableType } from "../../../store/calculation/calculation-input/TubingSlice";
import { fetchCableMotorEquipment, fetchCableWellEquipment, fetchRefreshChart, setCableTotalLength, setSelectedCable, setSelectedWellEquipment, setSelectedWellLockEquipment, setShowEquipmentTable } from "../../../store/calculation/calculation-output/cableSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import { fetchUpdatedSchematicEquipmentData } from "../../../store/calculation/calculationSlice";

const useCableFacade = () => {
    const dispatch = useAppDispatch();

    const updateCableTotalLength = (payload: number) => {
        return dispatch(setCableTotalLength(payload));
    }

    const updateWellChange = (payload: any): void => {
        dispatch(setShowEquipmentTable(payload?.show));
        dispatch(setHiddenCableType(payload?.selected));
        dispatch(fetchCableWellEquipment());
    }

    const updateSelectedWellEquipment = (updatedEquipments: any) => {
        dispatch(setSelectedWellEquipment(updatedEquipments));
        dispatch(fetchUpdatedSchematicEquipmentData());
    }

    const updateSelectedMotorEquipment = (updatedEquipments: any) => {
        dispatch(setHiddenCableMotorLead(updatedEquipments));
    }

    const updateSelectedLockPlate = (option: any) => {
        dispatch(setHiddenCableLockPlate(option));
    }

    const fetchMotorEquipment = () => {
        dispatch(fetchCableMotorEquipment());
    }

    const fetchWellEquipment = () => {
        dispatch(fetchCableWellEquipment());
    }

    const updateSelectedLockPlateEquipment = (updatedEquipments: any) => {
        dispatch(setSelectedWellLockEquipment(updatedEquipments));
    }

    const refreshChart = () => {
        dispatch(fetchRefreshChart());
    }

    const updateCableMotorLead = (payload: any) => {
        dispatch(setHiddenCableMotorLead(payload));
        dispatch(setSelectedWellLockEquipment([{}]))
    }

    const getSelectedCable = (payload: any) => {
        return dispatch(setSelectedCable(payload));
    };

    return {
        updateCableTotalLength,
        updateWellChange,
        updateSelectedWellEquipment,
        updateSelectedMotorEquipment,
        updateSelectedLockPlate,
        fetchMotorEquipment,
        updateSelectedLockPlateEquipment,
        refreshChart,
        fetchWellEquipment,
        updateCableMotorLead,
        getSelectedCable,
    };

}


export default useCableFacade;
